// Let the enclosing Turbo morph and Stimulus observers start the round animation.
export async function waitForRoundAnimation(element) {
  await new Promise(requestAnimationFrame);
  while (element.isConnected) {
    const round = element.closest('.game-screen')?.querySelector('[data-controller~="game-screen--round-info"]');
    const animation = round?.roundAnimation;
    if (!animation) return;
    await animation;
  }
}
